import { ProgressBar } from '@/components/ui';
import { usageRatio } from '@/features/billing/money';

/**
 * This month's metered allowances. An unlimited one is a sentence, not a bar
 * at a few percent that would suggest a ceiling that does not exist.
 */
export function StudentUsageMeters({ usage }) {
  return (
    <ul className="space-y-4">
      {usage.map((row) => {
        const ratio = usageRatio(row.used, row.limit);
        const atLimit = row.limit !== null && row.used >= row.limit;
        return (
          <li key={row.key}>
            <div className="mb-1 flex items-baseline justify-between gap-3 text-sm">
              <span className="text-ink font-medium">{row.label}</span>
              <span className="text-ink-muted text-xs tabular-nums">
                {row.limit === null
                  ? `${row.used} used · Unlimited`
                  : `${row.used} of ${row.limit}`}
              </span>
            </div>
            {ratio === null ? (
              <p className="text-ink-muted text-xs">No limit on your plan.</p>
            ) : (
              <ProgressBar value={ratio} />
            )}
            {atLimit && (
              <p className="mt-1 text-xs text-warning-700">
                Used up for this month. It resets on the 1st, or upgrade for unlimited.
              </p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
